import { useEffect, useState } from "react";
import Header from "../../Common/Header";
import YourSelf from "../../Components/YourSelf";
import Loader from "../../loader";

const YouSelfPage = () => {
  return (
    <>
      <YourSelf />
    </>
  );
};

export default YouSelfPage;
